export default __webpack_public_path__ + "static/michael-396d6cb2d6f30dce6ee7b0d56f59e153.png";